import { DolfinParser } from './base'
import DolfinRecord from '../../record'

/**
 * Backward-compatibility parser for deprecated DB-backed variables that were
 * previously resolved from RPC cache (e.g. previous_subscription_invoice.*).
 * When these variables appear in formulas, replace them with zero so formulas
 * keep evaluating instead of failing with unresolved tokens.
 */
export class LegacyDbVariableParser extends DolfinParser {
  constructor(recordData: DolfinRecord) {
    super(recordData)
  }

  execute(formula: string): string {
    return formula.replace(/\bprevious_subscription_invoice\.[a-zA-Z_][a-zA-Z0-9_]*\b/g, '0')
  }
}
